import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  AlertController,
  ToastController
} from "ionic-angular";
import { DatabaseProvider } from "../../providers/database/database";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/mergeMap";
import { AuthProvider } from "../../providers/auth/auth";
import * as _ from 'lodash';

@IonicPage()
@Component({
  selector: "page-admin-medications",
  templateUrl: "admin-medications.html"
})
export class AdminMedicationsPage {

  public medList: Observable<any[]>;
  public clinicList: Observable<any[]>;
  clinic: string;
  clinic_name: string;
  clinic_id: string;
  medications: any;
  medjson: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController
  ) {
    this.auth.getCurrentUser().then(user => {
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;

      this.medList = this.database
      .getMedications()
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      });

      this.clinicList = this.database
      .getClinics()
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      });
      this.database
      .getMedications()
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      }).subscribe((data) => {
        this.medjson = JSON.stringify(data);
      })
    });
  }

  ionViewDidLoad() {}

  loadMeds() {
    let parseJSON = JSON.parse(this.medications)

    _(parseJSON).forEach((item) => {
      let drug = _.omit(item, ['id']);
      if(this.clinic) {
   
        this.database.addMedicationByClinic(this.clinic, drug).then(_ => {
          console.log("Med added: ", drug);
        })
        .catch((err) => {
          console.log("Error adding medication: ", drug);
        })
    
      }
      else {
    
        this.database.addMedication(drug).then(_ => {
          console.log("Med added: ", drug);
        })
        .catch((err) => {
          console.log("Error adding medication: ", drug);
        })
 
      }

    });
  }

  add() {

  }

  filter()  {
    
  }

  showClinic(ev, clinic)  {
    console.log("Clinic selected: ", clinic.id)
  }

}



// WEBPACK FOOTER //
// ./src/pages/admin-medications/admin-medications.ts